<template>
  <div class="musicList">
    <!--    列表的顶部-->
    <div class="listTop">
      <div>
        <img :src="title.audioVideoCover" alt="">
        <img @click="handlePlay(title.audioVideoAddr)" :src="title.audioVideoAddr === src && isOpen ? zt : play" alt="">
      </div>
      <div>
        <p>{{title.audioVideoName}}</p>
        <p>{{title.audioVideoIntroduce}}</p>
      </div>
    </div>
    <!--  列表的播放所有部分-->
    <div class="allplay">
      <span>共{{dataList.length}}段讲解</span>
      <div>
        <span>播放全部</span>
        <img @click="allPlay" :src="allPlayAudio === true ? play : zt" alt="">
      </div>
    </div>
    <!--    音乐列表的部分-->
    <div class="playlist" v-for="(item,index) in dataList" :key="index">
      <div>
        <span>{{ index + 1 }}</span>
        <img :src="item.audioVideoCover" alt="">
      </div>
      <div>
        <p>{{ item.audioVideoName }}</p>
        <p>
          <img src="@/assets/muc.png" alt="">
          <span>{{ item.playAmount }}</span>
        </p>
      </div>
      <img @click="handlePlay(item.audioVideoAddr,item,index)" :src="item.audioVideoAddr === src && isOpen ? zt : play" alt="">
    </div>
    <audio style="display:none"  type="audio/mpeg"></audio>
  </div>
</template>

<script>
// import { addAudioNum, getListMusic, getTopMusic } from '@/api'

export default {
  name: 'list',
  data () {
    return {
      videoElement: [], // 创建一个数组
      play: require('@/assets/play3.png'),
      zt: require('@/assets/zt3.png'),
      dataListTop: {},
      src: '',
      mucid: null,
      isOpen: false,
      allPlayAudio: true,
      playIndex: 0,
      title: {
        amount: null,
        audioVideoAddr: 'https://daolansassoss.oss-cn-zhangjiakou.aliyuncs.com/temp/1621853130631.mp3',
        audioVideoCover: 'https://daolansassoss.oss-cn-zhangjiakou.aliyuncs.com/temp/1621853078002.jpg',
        audioVideoIntroduce: '芮城城隍庙创建于北宋大中祥符年间（公元1008-1016年）。元、明、清各代均有修茸，现中轴线上保存有享亭、献殿、大殿、寝殿四座古建筑，是宋、元、清建筑的集合群，是研究中国古代建筑史的实物例证，具有很高的艺术及鉴赏价值。2001年6月25日，被国务院公布为全国重点文物保护单位。现城隍庙总占地面积22.8亩。中轴线上依次排列享亭、献殿、大殿、寝殿、东西廊房等建筑。',
        audioVideoName: '城隍庙',
        audioVideoType: 1,
        audioVideoType_dictText: '音频',
        auditionMark: 1,
        auditionMark_dictText: '可试听',
        createBy: 'chenghuangmiao',
        createDept: null,
        createTime: '2021-05-24',
        delFlag: 0,
        delFlag_dictText: '正常',
        guideId: '1383341658132357121',
        id: '1396779471562461186',
        lengthAudioVideo: 74,
        mapId: '1396725870027542529',
        playAmount: null,
        punctuateId: null,
        remark: null,
        sequenceNum: null,
        status: 1,
        status_dictText: '正常',
        tenantId: '101',
        updateBy: null,
        updateTime: null,
        videoAddr: null,
        videoCover: null,
        videoDuration: null,
        videoIntroduce: null,
        videoName: null,
        videoPlayAmount: null
      }, // 头部列表的接口
      dataList: [{
        amount: null,
        audioVideoAddr: 'https://daolansassoss.oss-cn-zhangjiakou.aliyuncs.com/temp/1618903858711.mp3',
        audioVideoCover: 'https://daolansassoss.oss-cn-zhangjiakou.aliyuncs.com/temp/1618903842498.JPG',
        audioVideoIntroduce: '首先我们看到的这座建筑是牌楼，为2013年新建，牌楼，又名牌坊，是我国古代建筑中极为重要的一种类型，其建筑布局细腻，结构紧凑，形式多样，远看巍峨壮观，近看玲珑剔透。我们现在看到的这座牌楼中间为明楼，两侧为次楼，均为单檐歇山顶结构，木雕手法精细，画工精湛，牌楼象征着威严、荣誉、表彰。',
        audioVideoName: '牌楼',
        audioVideoType: 1,
        audioVideoType_dictText: '音频',
        auditionMark: 1,
        auditionMark_dictText: '可试听',
        createBy: 'chenghuangmiao',
        createDept: null,
        createTime: '2021-04-20',
        delFlag: 0,
        delFlag_dictText: '正常',
        guideId: '1383341658132357121',
        id: '1396777744738652162',
        lengthAudioVideo: 44,
        mapId: '1396725870027542529',
        playAmount: 0,
        punctuateId: '1396777744667348993',
        remark: null,
        sequenceNum: null,
        status: 1,
        status_dictText: '正常',
        tenantId: null,
        updateBy: 'chenghuangmiao',
        updateTime: '2021-04-21',
        videoAddr: null,
        videoCover: null,
        videoDuration: null,
        videoIntroduce: null,
        videoName: null,
        videoPlayAmount: null
      }]
    }
  },
  mounted () {
    // this.mucTopList()
    // this.mucList()
    this.allPlayAudio = true
    this.playIndex = 0
    this.videoElement = document.getElementsByTagName('audio') // 获取页面上所有的audio对象
  },
  methods: {
    // 播放全部
    allPlay () {
      // 转换播放和暂停按钮的图片（注意！！ 这里在播放完的this.allPlayAudio是要反写才可以重新播放不一样的音频）
      this.allPlayAudio = !this.allPlayAudio
      if (this.allPlayAudio === false && this.isOpen === false && this.dataList[this.playIndex].audioVideoAddr !== this.src) {
        // 如果点击的是播放全部按钮 并且 播放音乐的按钮开关为false 并且 音乐不一样 （就代表着音乐不一样但是播放开始了 代表着要切歌）
        this.isOpen = true
        this.src = this.dataList[this.playIndex].audioVideoAddr
        this.videoElement[0].src = this.dataList[this.playIndex].audioVideoAddr
        this.videoElement[0].play()
        this.audioNum(this.dataList[this.playIndex].id, this.playIndex)
      } else if (this.isOpen === false && this.dataList[this.playIndex].audioVideoAddr === this.src) {
        // 如果播放再次点击的音频一样但是暂停了 再点击播放  那就要继续刚刚的播放不重新赋予音乐链接
        this.src = this.dataList[this.playIndex].audioVideoAddr
        this.isOpen = true
        this.videoElement[0].play()
        this.audioNum(this.dataList[this.playIndex].id, this.playIndex)
      } else {
        // 点击暂停
        this.isOpen = false
        this.allPlayAudio = true
        this.videoElement[0].pause()
      }
      // 播放完写的逻辑
      this.videoElement[0].onended = () => {
        // 如果按顺序播放的索引音乐超过音乐列表的长度那么就赋值为0  并且暂停
        if (this.playIndex + 1 === this.dataList.length) {
          this.playIndex = 0
          this.videoElement[0].pause()
        } else {
          // 如果没超过0那就往上加1索引
          this.playIndex = this.playIndex + 1
        }
        this.src = this.dataList[this.playIndex].audioVideoAddr
        this.videoElement[0].src = this.dataList[this.playIndex].audioVideoAddr
        this.allPlayAudio = true
        this.isOpen = false
        // this.audioNum(this.dataList[this.playIndex].id, this.playIndex)
        this.allPlay()
      }
    },
    // 除了播放全部的按钮其他的播放
    handlePlay (item, itemList, index) {
      this.allPlayAudio = true
      this.playIndex = 0
      console.log(this.isOpen, item, this.src)
      // 切换音频
      if (this.isOpen === true && item === this.src) {
        this.isOpen = false
        this.videoElement[0].pause()
      } else if (this.isOpen === false && item === this.src) {
        this.src = item
        this.isOpen = true
        this.videoElement[0].play()
      } else {
        this.src = item
        this.videoElement[0].src = item
        this.isOpen = true
        this.videoElement[0].play()
      }
      // if (this.isOpen === true) {
      //   this.audioNum(itemList.id, index)
      // }
    }
    // async audioNum (id, index) {
    //   const { result } = await addAudioNum(id)
    //   console.log(result)
    //   this.dataList[index].playAmount = result
    // },
    // async mucTopList () {
    //   const { result } = await getTopMusic(this.$store.state.guideId, this.$store.state.mapId)
    //   this.title = result
    // },
    // async mucList () {
    //   const { result } = await getListMusic(this.$store.state.guideId, this.$store.state.mapId)
    //   this.dataList = result
    // }
  }
}
</script>

<style lang="scss" scoped>
.musicList {
  width: 100%;

  .listTop {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    border-bottom: 3px solid #F2F2F0;

    > div {
      vertical-align: middle;
      display: inline-block;
      position: relative;

      &:nth-child(1) {
        margin-right: 23px;

        img {
          width: 100px;
          height: 100px;
          border-radius: 7px;

          &:nth-child(2) {
            position: absolute;
            width: 50px;
            height: 50px;
            left: 26px;
            top: 26px;
          }
        }
      }

      &:nth-child(2) {
        width: 63%;
        p {
          &:nth-child(1) {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }

          &:nth-child(2) {
            font-size: 15px;
            font-weight: 500;
            color: #999999;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
    }
  }

  .allplay {
    padding: 7px 20px;

    img {
      width: 19px;
      height: 19px;
      border: 1px solid #333333;
      border-radius: 50%;
      vertical-align: middle;
      margin-left: 10px;
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      vertical-align: middle;
    }

    div {
      display: inline-block;
      float: right;
    }
  }

  .playlist {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;

    div {
      padding: 13px 0;
      border-bottom: 1px solid #F2F2F0;
      display: inline-block;

      &:nth-child(1) {
        width: 25%;
        vertical-align: middle;

        span {
          font-size: 16px;
          font-weight: 500;
          color: #999999;
          vertical-align: middle;
          position: absolute;
          left: 19px;
          top: 27px;
        }

        img {
          width: 41px;
          height: 40px;
          border-radius: 4px;
          vertical-align: middle;
          margin-right: 13px;
          margin-left: 25px;
        }
      }

      &:nth-child(2) {
        width: 75%;
        vertical-align: middle;

        > p {
          margin: 0;

          &:nth-child(1) {
            font-size: 14px;
            font-weight: 500;
            color: #000000;
            margin-bottom: 10px;
          }

          &:nth-child(2) {
            img {
              width: 14px;
              height: 13px;
              margin-right: 7px;
              vertical-align: middle;
            }

            span {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              vertical-align: middle;
            }
          }
        }
      }
    }

    > img {
      position: absolute;
      right: 46px;
      top: 26px;
      width: 19px;
      height: 19px;
      border: 1px solid #333333;
      border-radius: 50%;
    }
  }
}
</style>
